(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('dia-');
        $sessionStorageProvider.setKeyPrefix('dia-');
    }
})();
